import {
  Avatar,
  Box,
  Card,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getCrossTalks } from 'app/slices/crosstalk'
import LinkButton from 'components/LinkButton'
import NotFound from 'pages/NotFound'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

export default function CrossTalkDetailComponent() {
  let { id } = useParams<{ id: string }>()
  const dispatch = useAppDispatch()
  const status = useAppSelector((s) => s.CrossTalk.status)
  const data = useAppSelector((s) => s.CrossTalk.list)
  const value = data.find((f) => f._id === id)
  useEffect(() => {
    if (status === 'init') dispatch(getCrossTalks())
  }, [status, dispatch])

  if (status === 'completed' && !value) return <NotFound />
  else if (!value)
    return <Stack className="flex-row justify-center text-xl">Loading...</Stack>
  else
    return (
      <Box className="container py-10 xl:max-w-[1100px]">
        <Stack gap={2}>
          <Stack direction="row">
            <Typography fontWeight={600}>{value.date}</Typography>
          </Stack>
          <Stack gap={4}>
            <Typography className="font-semibold text-xl text-center">
              {value.title}
            </Typography>
            <Grid
              container
              spacing={{
                xs: 1,
                sm: 2,
                md: 3,
              }}
              alignItems="stretch"
            >
              {value.members.map((member) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={member.id}>
                    <Card
                      elevation={2}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: 2,
                        gap: 1,
                      }}
                    >
                      <Avatar
                        sx={{
                          cursor: 'pointer',
                          width: 120,
                          height: 120,
                        }}
                        src={member.avatar}
                      ></Avatar>
                      <Typography className="text-center font-semibold">
                        {member.name}
                      </Typography>
                      <Typography
                        className="text-center text-sm"
                        component={'div'}
                        dangerouslySetInnerHTML={{
                          __html: member.desc,
                        }}
                      ></Typography>
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
            <Card
              elevation={2}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 2,
                gap: 1,
              }}
            >
              {value.blocks.map((block) => {
                return (
                  <Stack key={block.id} gap={1}>
                    <Typography className="font-semibold">
                      {block.title}
                    </Typography>
                    <Typography
                      className="text-sm"
                      component={'div'}
                      dangerouslySetInnerHTML={{
                        __html: block.desc,
                      }}
                    ></Typography>
                    <Stack gap={2} my={2}>
                      {block.answers &&
                        Object.keys(block.answers).map((key) => {
                          const mem = value.members.find(
                            (f) => String(f.id) === String(key)
                          )
                          if (!mem) return null
                          return (
                            <Stack
                              direction={'row'}
                              key={key}
                              gap={2}
                              p={2}
                              bgcolor={'#eeea'}
                              className="rounded-lg"
                            >
                              <Avatar
                                sx={{
                                  width: 60,
                                  height: 60,
                                }}
                                src={mem.avatar}
                              ></Avatar>
                              <Typography
                                className="text-sm"
                                component="div"
                                dangerouslySetInnerHTML={{
                                  __html: block.answers[key],
                                }}
                              ></Typography>
                            </Stack>
                          )
                        })}
                    </Stack>
                  </Stack>
                )
              })}
            </Card>
          </Stack>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack className="items-center justify-center gap-4 my-8">
          <LinkButton
            text="他の座談会も見る"
            arrowIcon
            to={'/fellow#crosstalk'}
            sx={{
              border: 'solid currentColor',
              borderWidth: '2px 0',
            }}
          />
        </Stack>
      </Box>
    )
}
